

































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import TenantEnginePlugin from "../TenantEnginePlugin.vue";

import {
  ContentSection,
  SectionOverview,
  FormSelect,
  OptionalSelection
} from "sitewhere-ide-components";
import { VCheckbox, VCard } from "vuetify/lib";

import { ITenantEngineConfiguration } from "sitewhere-rest-api";
import { IDeviceRegistrationConfiguration } from "sitewhere-configuration-model";
import {
  IInstanceConfiguration,
  IDeviceType,
  IDeviceTypeSearchCriteria,
  IDeviceTypeResponseFormat,
  IDeviceTypeSearchResults,
  ICustomer,
  ICustomerSearchCriteria,
  ICustomerResponseFormat,
  ICustomerSearchResults,
  IArea,
  IAreaSearchCriteria,
  IAreaResponseFormat,
  IAreaSearchResults,
  IAsset,
  IAssetSearchCriteria,
  IAssetResponseFormat,
  IAssetSearchResults
} from "sitewhere-rest-api";
import { AxiosResponse } from "axios";
import {
  showError,
  listDeviceTypes,
  listCustomers,
  listAreas,
  listAssets
} from "sitewhere-ide-common";

@Component({
  components: {
    VCheckbox,
    VCard,
    ContentSection,
    TenantEnginePlugin,
    SectionOverview,
    FormSelect,
    OptionalSelection
  }
})
export default class DeviceRegsitrationPlugin extends Vue {
  @Prop() readonly configuration!: ITenantEngineConfiguration;

  allowNewRegistrations = false;

  deviceTypes: IDeviceType[] = [];
  deviceTypeToken: string | null = null;

  customers: ICustomer[] = [];
  customerToken: string | null = null;

  areas: IArea[] = [];
  areaToken: string | null = null;

  assets: IAsset[] = [];
  assetToken: string | null = null;

  /** Get tenant configuration for device registration */
  get deviceRegistration(): IDeviceRegistrationConfiguration {
    return this.configuration ? this.configuration.tenantConfiguration : null;
  }

  /** Get instance configuraton information */
  get instanceManagement(): IInstanceConfiguration | null {
    return this.configuration ? this.configuration.instanceConfiguration : null;
  }

  @Watch("deviceRegistration", { immediate: true })
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  onConfigurationUpdated(updated: IDeviceRegistrationConfiguration) {
    // Load data for dropdowns.
    this.loadDeviceTypes();
    this.loadCustomers();
    this.loadAreas();
    this.loadAssets();

    // Verify that config structure is valid.
    this.assureAssignmentDefaults();

    // Set local variables from configuration.
    this.allowNewRegistrations = this.deviceRegistration.allowNewDevices;
    this.deviceTypeToken = this.deviceRegistration.assignmentDefaults.defaultDeviceTypeToken;
    this.customerToken = this.deviceRegistration.assignmentDefaults.defaultCustomerToken;
    this.areaToken = this.deviceRegistration.assignmentDefaults.defaultAreaToken;
    this.assetToken = this.deviceRegistration.assignmentDefaults.defaultAssetToken;
  }

  @Watch("allowNewRegistrations")
  onAllowNewRegistrationsUpdate(updated: boolean) {
    this.deviceRegistration.allowNewDevices = updated;
    this.markDirty();
  }

  @Watch("deviceTypeToken")
  onDeviceTypeTokenUpdated(updated: string) {
    this.deviceRegistration.assignmentDefaults.defaultDeviceTypeToken = updated;
    this.markDirty();
  }

  @Watch("customerToken")
  onCustomerTokenUpdated(updated: string) {
    this.deviceRegistration.assignmentDefaults.defaultCustomerToken = updated;
    this.markDirty();
  }

  @Watch("areaToken")
  onAreaTokenUpdated(updated: string) {
    this.deviceRegistration.assignmentDefaults.defaultAreaToken = updated;
    this.markDirty();
  }

  @Watch("assetToken")
  onAssetTokenUpdated(updated: string) {
    this.deviceRegistration.assignmentDefaults.defaultAssetToken = updated;
    this.markDirty();
  }

  /** Assure assignment defaults section if null */
  assureAssignmentDefaults(): void {
    if (!this.deviceRegistration.assignmentDefaults) {
      this.deviceRegistration.assignmentDefaults = {
        defaultDeviceTypeToken: null,
        defaultCustomerToken: null,
        defaultAreaToken: null,
        defaultAssetToken: null
      };
    }
  }

  /** Load device types asynchronously */
  async loadDeviceTypes() {
    try {
      const criteria: IDeviceTypeSearchCriteria = {
        pageNumber: 1,
        pageSize: 0
      };
      const format: IDeviceTypeResponseFormat = {};
      const response: AxiosResponse<IDeviceTypeSearchResults> = await listDeviceTypes(
        this.$store,
        criteria,
        format
      );
      this.deviceTypes = response.data.results;
    } catch (err) {
      showError(this, err);
    }
  }

  /** Load customers asynchronously */
  async loadCustomers() {
    try {
      const criteria: ICustomerSearchCriteria = {
        pageNumber: 1,
        pageSize: 0
      };
      const format: ICustomerResponseFormat = {};
      const response: AxiosResponse<ICustomerSearchResults> = await listCustomers(
        this.$store,
        criteria,
        format
      );
      this.customers = response.data.results;
    } catch (err) {
      showError(this, err);
    }
  }

  /** Load areas asynchronously */
  async loadAreas() {
    try {
      const criteria: IAreaSearchCriteria = {
        pageNumber: 1,
        pageSize: 0
      };
      const format: IAreaResponseFormat = {};
      const response: AxiosResponse<IAreaSearchResults> = await listAreas(
        this.$store,
        criteria,
        format
      );
      this.areas = response.data.results;
    } catch (err) {
      showError(this, err);
    }
  }

  /** Load assets asynchronously */
  async loadAssets() {
    try {
      const criteria: IAssetSearchCriteria = {
        pageNumber: 1,
        pageSize: 0
      };
      const format: IAssetResponseFormat = {};
      const response: AxiosResponse<IAssetSearchResults> = await listAssets(
        this.$store,
        criteria,
        format
      );
      this.assets = response.data.results;
    } catch (err) {
      showError(this, err);
    }
  }

  /** Mark data as having been updated */
  markDirty(): void {
    this.$emit("dirty");
  }
}
